import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/admin/app';
import DashboardWidget from 'flarum/admin/components/DashboardWidget';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
export default class MiniStatisticsWidget extends DashboardWidget {
  constructor() {
    super(...arguments);
    _defineProperty(this, "entities", ['users', 'discussions', 'posts']);
    _defineProperty(this, "lifetimeData", void 0);
    _defineProperty(this, "loadingLifetime", true);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.loadLifetimeData();
  }
  async loadLifetimeData() {
    this.loadingLifetime = true;
    m.redraw();
    const data = await app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/statistics',
      params: {
        period: 'lifetime'
      }
    });
    this.lifetimeData = data;
    this.loadingLifetime = false;
    m.redraw();
  }
  className() {
    return 'StatisticsWidget StatisticsWidget--mini';
  }
  content() {
    return m("div", {
      className: "StatisticsWidget-table"
    }, m("h4", {
      className: "StatisticsWidget-title"
    }, app.translator.trans('flarum-statistics.admin.statistics.mini_heading')), m("div", {
      className: "StatisticsWidget-entities"
    }, m("div", {
      className: "StatisticsWidget-labels"
    }, m("div", {
      className: "StatisticsWidget-label"
    }, app.translator.trans('flarum-statistics.admin.statistics.total_label'))), this.entities.map(entity => {
      const totalCount = this.loadingLifetime ? app.translator.trans('flarum-statistics.admin.statistics.loading') : this.getTotalCount(entity);
      return m("div", {
        className: "StatisticsWidget-entity"
      }, m("h3", {
        className: "StatisticsWidget-heading"
      }, app.translator.trans('flarum-statistics.admin.statistics.' + entity + '_heading')), m("div", {
        className: "StatisticsWidget-total",
        title: totalCount
      }, this.loadingLifetime ? m(LoadingIndicator, {
        display: "inline"
      }) : abbreviateNumber(totalCount)));
    })), m("div", {
      className: "StatisticsWidget-viewFull"
    }, m(Link, {
      href: app.route('extension', {
        id: 'flarum-statistics'
      })
    }, app.translator.trans('flarum-statistics.admin.statistics.view_full'))));
  }
  getTotalCount(entity) {
    return this.lifetimeData[entity];
  }
}
flarum.reg.add('flarum-statistics', 'admin/components/MiniStatisticsWidget', MiniStatisticsWidget);